import React from 'react';
import * as classes from './header.module.css';

export default function Header() {
  return (
    <div>
      <div className={classes.container}>
        <img
          className={`${classes.img} animate`}
          src="https://b.zmtcdn.com/data/o2_assets/b90ed7f7c7f06ce7a5b94b967d4ce3eb1621255947.png"
          alt="Fedding India Image"
        />
      </div>
      <div className={classes.logo}>
        <img
          className={`${classes.img} animate`}
          src="https://b.zmtcdn.com/data/o2_assets/68ab7bac05d3ec3bff89a2e428e5b4f71619504075.png"
          alt="Fedding India Logo"
        />
        <p className={`${classes.tagline}`}>
          Serving daily meals for a hunger-free India
        </p>
      </div>
    </div>
  );
}
